<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{navigationTitle}}</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form
        ref="reference"
        :model="reference"
        size="small"
        label-width="80px"
        label-position="top"
        :rules="rules"
      >
        <el-form-item
          label="共识题目"
          prop="name"
        >
          <el-col :span="15">
            <el-input
              :disabled="true"
              type="textarea"
              v-model="reference.name"
              placeholder="请输入项目名称"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item
          label="参会专家"
          prop="expert_id"
          required
        >
          <el-col :span="10">
            <el-select
              v-model="reference.expert_id"
              remote
              multiple
              filterable
              placeholder="参会专家"
            >
              <el-option
                v-for="item in expertObject"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
              <!-- 这里边再加一个分页 -->
              <!-- <el-pagination
                style="text-align: center;"
                layout="prev, pager, next"
                @current-change="currentchange"
                @prev-click="prevClick"
                @next-click="nextClick"
                :current-page.sync="currentPage"
                hide-on-single-page
                :page-count="expertObject.pages"
              >
              </el-pagination> -->
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="目标期刊">
          <el-col :span="10">
            <el-input
              v-model="reference.target_journals"
              placeholder="请输入目标期刊"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item
          label="期刊类型"
          prop="journal_type"
          required
        >
          <el-radio-group v-model="reference.journal_type">
            <el-radio :label="1">整篇</el-radio>
            <el-radio :label="2">整期</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="抽印册数">
          <el-col :span="10">
            <el-input
              type="number"
              v-model="reference.nums"
              placeholder="请输入抽印册数"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="广告">
          <el-col :span="10">
            <el-select
              multiple
              v-model="reference.ad"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="制作规格">
          <el-col :span="10">
            <el-input
              v-model="reference.spec"
              placeholder="请输入制作规格"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="配送地址">
          <el-col>
            <el-input
              v-model="reference.address"
              placeholder="请输入配送地址"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label=" 快递单号">
          <el-col>
            <el-input
              v-model="reference.express_num"
              placeholder="请输入快递单号"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="联系人">
          <el-col :span="10">
            <el-input
              v-model="reference.user_name"
              placeholder="请输入联系人"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="电话">
          <el-col :span="10">
            <el-input
              v-model="reference.user_phone"
              placeholder="请输入电话"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="邮件">
          <el-col :span="10">
            <el-input
              v-model="reference.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="微信号">
          <el-col :span="10">
            <el-input
              v-model="reference.wechat"
              placeholder="请输入微信号"
            ></el-input>
          </el-col>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="reference.remarks"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            style="background: #484c7f"
            @click="submitForm('reference')"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
 
<script>
export default {
  name: 'editorProject',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error('请选择参会专家'));
      } else {
        callback();
      }
    };
    return {
      navigationTitle: '录入期刊抽印本',
      expertObject: [],
      reference: {
        id: '',//主键id 有时修改 空时添加
        p_id: '',//项目id
        name: '',//共识题目
        expert_id: [],//牵头专家id
        writer: '',//执笔人
        author: '',//作者
        target_journals: '',//目标期刊
        journal_type: '',//期刊类型 
        nums: '',//抽印册数 
        spec: '',//规格
        address: '',//配送地址
        express_num: '',//快递单号
        user_name: '',//联系人
        user_phone: '',//联系电话 
        email: '',//邮箱 
        wechat: '',//微信号  
        remarks: '',//备注  
        ad: [],//广告封面 封1 封2 封3 封4 中插5 1，2，3，4，5  
      },
      rules: {
        name: [
          { required: true, message: '请输入共识题目', trigger: 'blur' },
        ],
        expert_id: [
          { validator: validatePass, trigger: 'change' }
        ],
        journal_type: [
          { required: true, message: '请选择期刊类型', trigger: 'change' },
        ],
        // nums: [
        //   { required: true, message: '请输入期刊册数', trigger: 'blur' },
        // ], 
      },
      total: 0,//总条目数
      pagesize: 6,//每页显示条目个数
      currentPage: 1,//当前页数  
      value: '',
      options: [{
        value: 1,
        label: '封1'
      }, {
        value: 2,
        label: '封2'
      }, {
        value: 3,
        label: '封3'
      }, {
        value: 4,
        label: '封4'
      }, {
        value: 5,
        label: '封5'
      }],
    }
  },
  created () {
    if (this.$route.query.id != "") { this.editorExtractionPrinting(this.$route.query.id) } else { this.getProjectList() }
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) {
      this.reference.p_id = this.$route.query.project_id
      this.reference.name = this.$route.query.title
    }
    this.getExpertList()
  },
  methods: {
    //编辑进来的
    async editorExtractionPrinting (id) {
      this.navigationTitle = '编辑期刊抽印本'
      const { data: data } = await this.$http.post('copy/info', {
        id,
      })
      this.reference = data.data
    },
    //参会专家 获取专家列表
    async getExpertList () {
      const { data: data } = await this.$http.post('expert/all')
      this.expertObject = data.data
    },
    async getProjectList () {
      const { data: data } = await this.$http.post('select/expert', { project_id: this.$route.query.project_id })
      this.reference.expert_id = data.data
    },
    //获取广告
    async getAdvertisement () {
      const { data: data } = await this.$http.get('index/adCate', {
        params: {
          page: 1,
          limit: 2
        }
      })
      console.log(data);
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr () {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单 
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交接口 
    async submitApi () {
      const { data: data } = await this.$http.post('copy/add', this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //点击每一页  
    currentchange (e) {
      this.currentPage = e
      this.getExpertList()
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      this.getExpertList()
    },
    //下一页 
    nextClick (e) {
      this.currentPage = e
      this.getExpertList()
    },
    backProject () {
      this.$router.back()
    },
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }
  /deep/.el-select {
    display: block;
  }
  //  上传文件样式
  .uploads {
    display: flex;
    .upload-demo {
      display: flex;
      // align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;
        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    // overflow-y: auto;
  }
  /deep/.el-select {
    display: block;
  }
  // 上传图片的样式
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    width: 66px;
    height: 66px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30px;
    height: 30px;
    line-height: 66px;
    text-align: center;
  }
  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }
  // 上传图片样式结束

  /deep/ .el-card {
    overflow: visible;
  }

  .Penmanship {
    position: absolute;
    top: 9px;
    left: 315px;
    font-size: 12px;
    color: #cc0808;
  }
  .ticks {
    color: #cc0808;
    font-size: 12px;
    margin-top: 10px;
    margin-left: 13px;
  }
  //新的
  .uploads-box {
    position: relative;
    .upload-demo {
      align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }
      .box {
        position: absolute;
        top: 1px;
        left: 80px;
        width: 421px;
        height: 32px;
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
      }
    }
    .ticks {
      position: absolute;
      top: -10px;
      left: 500px;
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }
}
</style>
